module.exports = __webpack_public_path__ + "static/media/arrow-up-down-color-black.70eebbc3.svg";